import type { MapConfiguration } from 'ui-components/google-map/types/types';

export const stringifyMapConfig = (config: MapConfiguration) => ({
    ...config,
    ne: config.ne?.join(','),
    sw: config.sw?.join(','),
});

export const parseUserSettingsCoordinates = (latLng?: string) => latLng?.split(',').map(Number);
